import PaymentController from '../../api/controllers/paymentController';
import { paymentCancelActionType } from '../../actionTypes';

export const initiateCancelTransaction = () => (dispatch, getState) => {
  const { config } = getState();
  const { sourceRef } = config || {};
  dispatch({
    type: paymentCancelActionType.CANCEL_TRANSACTION_REQUEST,
    payload: {},
  });
  PaymentController.postCancelTransaction(null, { sourceRef })
    .then(({ data: respData }) => {
      const { pgData, returnUrl } = respData || {};
      dispatch({
        type: paymentCancelActionType.CANCEL_TRANSACTION_SUCCESS,
        payload: { pgData, returnUrl },
      });
    })
    .catch((errorData) => {
      dispatch({
        type: paymentCancelActionType.CANCEL_TRANSACTION_ERROR,
        payload: {},
      });
    });
};



// WEBPACK FOOTER //
// ./actions/onPaymentCancel/initiateCancel.js